import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import withLayoutColorClasses from '../../hoc/with-layout-color-classes';

import styles from './separator.scss';

export const HorizontalSeparator = ({
  className,
  inverted,
  separatorBackgroundColorClassName,
}) => (
  <div
    className={classNames(
      styles.horizontal,
      className,
      getClassName(inverted, separatorBackgroundColorClassName),
    )}
  />
);

HorizontalSeparator.propTypes = {
  className: PropTypes.string,
  inverted: PropTypes.bool,
  separatorBackgroundColorClassName: PropTypes.string,
};

export const HorizontalSeparatorForPostCard =
  withLayoutColorClasses(HorizontalSeparator);

export const VerticalSeparator = ({ className, inverted }) => (
  <div
    className={classNames(styles.vertical, className, getClassName(inverted))}
  />
);

VerticalSeparator.propTypes = {
  className: PropTypes.string,
  inverted: PropTypes.bool,
};

function getClassName(inverted, separatorBackgroundColorClassName) {
  return inverted
    ? 'blog-inverted-separator-background-color'
    : separatorBackgroundColorClassName || 'blog-separator-background-color';
}

export const BulletSeparator = ({
  className,
  inverted,
  separatorBackgroundColorClassName,
}) => (
  <div
    className={classNames(
      styles.bullet,
      className,
      getClassName(inverted, separatorBackgroundColorClassName),
    )}
  />
);

BulletSeparator.propTypes = {
  className: PropTypes.string,
  inverted: PropTypes.bool,
  separatorBackgroundColorClassName: PropTypes.string.isRequired,
};

export const BulletSeparatorForPost = withLayoutColorClasses(BulletSeparator);

export const Spacing = ({ width }) => <div style={{ minWidth: width }} />;

Spacing.propTypes = {
  width: PropTypes.any.isRequired,
};
